import script from "./ProjectByIdView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectByIdView.vue?vue&type=script&setup=true&lang=js"

import "./ProjectByIdView.vue?vue&type=style&index=0&id=e57886b2&lang=scss&scoped=true"
import "./ProjectByIdView.vue?vue&type=style&index=1&id=e57886b2&lang=css"

import exportComponent from "/workdir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e57886b2"]])

export default __exports__